import axios from 'axios';

const API = {
    async getChannels() {
        const {
            data
        } = await axios.get('/list/channels');
        return data.data.cls;
    },
    async getNewsList(cid, index = 0, len = 10) {
        const {
            data
        } = await axios.get(`/list/${cid}/${index}/${len}`)
        return data.data;
    }
}

export default API;